module.exports = __webpack_public_path__ + "media/theme/top_accordion_PC_1_open.-08c28de8.png";